import * as Types from '../constants/actionTypes';
  
  export default (state = {}, action) => {
    //console.log(`state in auth is :`,state);
    switch (action.type) {
      
    case Types.SET_TOKEN: 
      return {
        ...state,
        token: action.token,
        isUserAuthenticated: true
      }
    
    case Types.SET_REFRESH_TOKEN: 
        return {
          ...state,
          refreshToken:action.refreshToken,
        }

    case Types.AUTH_LOGIN_ERROR: {
      return {
        ...state,
        authLoginError: action.authLoginError
      }
    }
    case Types.IS_USER_AUTHENTICATED: {
      return {
        ...state,
        isUserAuthenticated: action.isUserAuthenticated
      }
    }

    case Types.ON_LOGOUT:{
      delete state.refreshToken
      delete state.token
      return {
        ...state,
        isUserAuthenticated: false,
        noRedirect : false
      } 
    }

    case Types.ON_MANUAL_LOGOUT:{
      delete state.refreshToken
      delete state.token
      return {
        ...state,
        isUserAuthenticated: false,
        noRedirect : true
      } 
    }
    
    /* Forgot Password Reducers */
    case Types.ADMIN_FORGOT_PASSWORD_ERROR: 
      return {
        ...state,
        forgotPswdError: action.forgotPswdError
      }
    case Types.ADMIN_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePWDError: action.changePWDError
      }

      // Activation Process APIs

    case Types.INITIATE_SET_PASSWORD_SUCCESS:
      return {
        ...state,
        isSetPasswordEnabled: true
      }
    case Types.USER_ACTIVATION_INITIATE_RESEND_ACTIVATION:
      return {
        ...state,
        isResendActivationRequired: true,
        isSetPasswordEnabled: false
      }
    case Types.PORTAL_USER_ACTIVATION_RESEND_FAILED:
      return {
        ...state,
        isResendErrorMessage: action.errorMessage
      }
    case Types.PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS:
      return {
        ...state,
        isResendActivationRequired: false,
        isResendActivationSuccess: true
      }
      case Types.PORTAL_USER_ACTIVATION_FAILED:
        return {
          ...state,
          userActivateErrorMessage: action.errorMessage
        }
      case Types.SET_ADMIN_RESEND_ERROR_MESSAGE: 
        return {
          ...state,
          isResendAdminuserError: action.errorMessage
        }
      default:
        return state;
    }
};